import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faFileAlt } from '@fortawesome/free-solid-svg-icons';

//Components
import TextField from '../../../../../components/TextField';
import RichTextEditor from '../../../../../components/RichTextEditor';
import TabelaListagemFichas from '../../../../../components/TabelaListagemFichas/TabelaListagemFichas';
import ModalCustomized from '../../../../../components/Modal/Modal';

//Helpers
import { showMessage } from '../../../../../helpers/message';
import { objCampo, validarCampos } from '../../../../../helpers/ValidadorDeCampos';

//API
import tipoDeFiscalizacao_api from '../../../../../api/tipoDeFIscalizacao_api';
import integracao_api from '../../../../../api/integracao_api';
import tipoIntegracao_api from '../../../../../api/tipoIntegracao_api';
import modelosEmail_api from '../../../../../api/modelosEmail_api';
import variaveisSistema_api from '../../../../../api/variaveisSistema_api';

//Context
import { useAuth } from '../../../../../context/auth';
import roteiroDeFiscalizacao_api from '../../../../../api/roteiroDeFiscalizacao_api';

export default function Identificacao({ tipoDeFiscalizacao, setTipoDeFiscalizacao, loadTipoDeFiscalizacaoItem, editavel = false }) {
  //State para pegar erros
  const [errors, setErrors] = useState({});

  //State para pegar os roteiros
  const [listaRoteiroFiscalizacao, setListaRoteiroFiscalizacao] = useState([]);

  //State para pegar os methods de cada secretária
  const [listmethodsIntregacao, setListMethodsIntregacao] = useState([]);

  //Estado de controle das opções de tipo de integração
  const [tipoIntegracao, setTipoIntegracao] = useState([]);

  //Estado de controle da lista de modelos de email
  const [modelosEmail, setModelosEmail] = useState([]);

  //State de lista de Variaveis do sistema
  const [listaVariaveisSistema, setListaVariaveisSistema] = useState([]);

  //State para visibilidade do modal de variáveis do Termo de Dívida Ativa
  const [isModalListaVariaveis, setIsModalListaVariaveis] = useState(false);

  const toggleModalListaVariaveis = () => setIsModalListaVariaveis(!isModalListaVariaveis);

  const { setLoading } = useAuth();

  //Função para pegar os roteiros de fiscalização
  const loadRoteiroFiscalizacao = () => {
    setLoading(true);
    roteiroDeFiscalizacao_api.getList()
      .then(response => {
        setListaRoteiroFiscalizacao(response.data);
      })
      .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
      .finally(() => setLoading(false));
  }

  //Função que carrega as integrações pelo metodo
  const loadMethodsIntregacao = (tipos) => {
    setLoading(true);
    integracao_api.GetListIntregacoes({ method: "GET", tipoIntegracoes: [...tipos] })
      .then(response => {
        setListMethodsIntregacao(response.data);
        setTipoDeFiscalizacao(prev => {
          prev.integracoes = prev.integracoes.filter(x => response.data.some(integracao => integracao.id == x));

          return { ...prev };
        });
      })
      .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
      .finally(() => setLoading(false));
  }

  //Função que carrega os tipos de integração
  const loadTiposIntegracao = () => {
    setLoading(true);
    tipoIntegracao_api.getList().then(response => {
      let _data = response.data?.length > 0 ? response.data.filter(x => x.identificacao !== "SolicitacaoFiscalizacao") : []
      setTipoIntegracao(_data);
    })
      .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
      .finally(() => setLoading(false));
  }

  const loadModelosEmail = () => {
    setLoading(true);
    modelosEmail_api.getList().then(response => {
      console.log(response.data)
      setModelosEmail(response.data.filter(x => x.status === "Ativo"));
    }).catch(e => showMessage("Erro", e.message, "error", null))
      .finally(f => setLoading(false));
  }

  //Função de onChange dos campos
  const onChange = (e) => {
    const { name, value } = e.target;

    setTipoDeFiscalizacao({
      ...tipoDeFiscalizacao,
      [name]: value
    });
  }

  //Função para campos select
  const onChangeRoteiroFiscalizacao = (value, e) => {
    setTipoDeFiscalizacao({
      ...tipoDeFiscalizacao,
      [e.name]: value ? value.value : null,
    });
  }

  const onChangeModeloEmailDividaAtiva = (value, e) => {
    setTipoDeFiscalizacao({
      ...tipoDeFiscalizacao,
      [e.name]: value ? value.value : null,
    });
  }

  //Função de onchange para os campos com multipla seleção
  const onChangeMultiple = (e, select) => {
    const { name } = select;

    if (name == "tipoIntegracoes" && e && e.length > 0) {
      loadMethodsIntregacao(e.map(value => value.value));
    }

    const _tipoDeFiscalizacao = {
      ...tipoDeFiscalizacao,
      [name]: e && e.length > 0 ? e.map(value => value.value) : []
    };
    setTipoDeFiscalizacao(prev => ({ ..._tipoDeFiscalizacao }));
  }

  //Campos obrigatorios
  const camposIdentificacao = [
    objCampo({ name: "identificacao", required: true }),
    objCampo({ name: "status", required: true }),
    objCampo({ name: "roteiroFiscalizacao_Id", required: true }),
  ];

  //Função para salvar tipo de fiscalização
  const salvarTipoFiscalizacao = () => {
    const _errors = validarCampos(tipoDeFiscalizacao, camposIdentificacao);
    setErrors(_errors[0]);

    if (_errors[1].length > 0)
      return true;

    const _tipoDeFiscalizacao = { ...tipoDeFiscalizacao };
    _tipoDeFiscalizacao.tipoIntegracao = _tipoDeFiscalizacao.tipoIntegracao == "Nenhum" ? null : _tipoDeFiscalizacao.tipoIntegracao;

    if (_tipoDeFiscalizacao.id) {
      setLoading(true)
      tipoDeFiscalizacao_api.put(_tipoDeFiscalizacao).then(response => {
        showMessage("Aviso", "Operação realizada com sucesso", "success", () => { loadTipoDeFiscalizacaoItem() });
      })
        .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
        .finally(() => setLoading(false))
    } else {
      setLoading(true)
      tipoDeFiscalizacao_api.post(_tipoDeFiscalizacao).then(response => {
        showMessage("Aviso", "Operação realizada com sucesso", "success", () => { loadTipoDeFiscalizacaoItem(response.data) });
      })
        .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
        .finally(() => setLoading(false))
    }
  }

  const loadListaVariaveisSistema = () => {
    setLoading(true);
    variaveisSistema_api.getList().then(response => {
      setListaVariaveisSistema(response.data);
    })
      .catch(e => showMessage("Erro", e.message, "error", null))
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    loadRoteiroFiscalizacao();
    loadTiposIntegracao();
    loadModelosEmail();
    loadListaVariaveisSistema();
  }, []);

  useEffect(() => {
    if (tipoDeFiscalizacao.tipoIntegracoes && tipoDeFiscalizacao.tipoIntegracoes.length > 0 && listmethodsIntregacao.length == 0)
      loadMethodsIntregacao(tipoDeFiscalizacao.tipoIntegracoes);
  }, [tipoDeFiscalizacao]);


  return <>
    <Row>
      <h5 className='mb-3'>Identificação</h5>
      <Col md={12} lg={6}>
        <TextField
          name={"identificacao"}
          label={"* Identificação"}
          value={tipoDeFiscalizacao.identificacao}
          invalid={!!errors.identificacao}
          onChange={onChange}
          maxLength={100}
          disabled={!editavel}
        />
      </Col>
      <Col md={12} lg={4}>
        <TextField
          name={"indicarEndereco"}
          label={"* Indicação do Endereço e Data/Hora"}
          type={"select"}
          value={tipoDeFiscalizacao.indicarEndereco}
          options={
            [
              { label: "Automático", value: "Automático" },
              { value: "Manual", label: "Manual" }
            ]
          }
          onChange={onChange}
          maxLength={10}
          disabled={!editavel}
        />
      </Col>
      <Col md={12} lg={2}>
        <TextField
          type={"select"}
          label="* Status"
          name={"status"}
          options={
            [
              { label: "Ativo", value: "Ativo" },
              { value: "Inativo", label: "Inativo" }
            ]
          }
          onChange={onChange}
          value={tipoDeFiscalizacao.status}
          invalid={!!errors.status}
          disabled={!editavel}
        />
      </Col>
      <Col md={12} lg={4}>
        <TextField
          type={"select"}
          label="* Fluxo Administrativo"
          name={"roteiroFiscalizacao_Id"}
          searchable
          options={listaRoteiroFiscalizacao.map(v => { return { value: v.id.toString(), label: v.identificacao } })}
          onChange={onChangeRoteiroFiscalizacao}
          value={
            listaRoteiroFiscalizacao.filter(value => value.id == tipoDeFiscalizacao.roteiroFiscalizacao_Id)
              .map(v => { return { value: v.id.toString(), label: v.identificacao } })
          }
          invalid={!!errors.roteiroFiscalizacao_Id}
          disabled={!editavel}
        />
      </Col>
      <Col md={12} lg={4}>
        <TextField
          type={"select"}
          label="* Permite Fiscalização Avulsa"
          name={"permiteFiscalizacaoAvulsa"}
          options={
            [
              { value: "true", label: "Ativo" },
              { value: "false", label: "Inativo" }
            ]
          }
          onChange={onChange}
          value={tipoDeFiscalizacao.permiteFiscalizacaoAvulsa}
          invalid={!!errors.permiteFiscalizacaoAvulsa}
          disabled={!editavel}
        />
      </Col>
      <Col md={12} lg={4}>
        <TextField
          type={"select"}
          label="* Fiscalização de Plano de Trabalho"
          name={"fiscalizaPlanoTrabalho"}
          options={
            [
              { label: "Sim", value: "true" },
              { label: "Não", value: "false" }
            ]
          }
          onChange={onChange}
          value={tipoDeFiscalizacao.fiscalizaPlanoTrabalho}
          disabled={!editavel}
        />
      </Col>
      <Col md={12} lg={4}>
        <TextField
          type={"select"}
          label="* Exibir dados óbito"
          name={"exibirDadosObito"}
          options={
            [
              { value: "true", label: "Sim" },
              { value: "false", label: "Não" }
            ]
          }
          onChange={onChange}
          value={tipoDeFiscalizacao.exibirDadosObito}
          disabled={!editavel}
        />
      </Col>
      <Col md={12} lg={4}>
        <TextField
          type={"select"}
          label="* Considerar Dias Não Úteis no Prazo"
          name={"considerarDiasNaoUteis"}
          options={
            [
              { value: "true", label: "Sim" },
              { value: "false", label: "Não" }
            ]
          }
          onChange={onChange}
          value={tipoDeFiscalizacao.considerarDiasNaoUteis}
          disabled={!editavel}
        />
      </Col>

      <Col md={12} lg={4}>
        <TextField
          type={"select"}
          label="* Permitir Reserta Infração"
          name={"permiteReset"}
          options={
            [
              { value: "true", label: "Sim" },
              { value: "false", label: "Não" }
            ]
          }
          onChange={onChange}
          value={tipoDeFiscalizacao.permiteReset}
          disabled={!editavel}
        />
      </Col>

      <Col md={12} lg={12}>
        <TextField
          type={"select"}
          label="Modelo E-mail Inscrição Dívida Ativa"
          name={"modeloEmailDividaAtiva_Id"}
          searchable
          options={modelosEmail.map(v => { return { value: v.id.toString(), label: v.identificacao } })}
          onChange={onChangeModeloEmailDividaAtiva}
          value={
            modelosEmail.filter(value => value.id == tipoDeFiscalizacao?.modeloEmailDividaAtiva_Id)
              .map(v => { return { value: v.id.toString(), label: v.identificacao } })
          }
          disabled={!editavel}
        />
      </Col>

      <Col md={12} lg={12}>
        <TextField
          type={"select"}
          label="Tipo de intregação"
          name={"tipoIntegracoes"}
          options={tipoIntegracao.map(value => ({ value: value.id, label: value.identificacao }))}
          onChange={onChangeMultiple}
          value={tipoIntegracao
            .filter(value => tipoDeFiscalizacao.tipoIntegracoes.length > 0 && tipoDeFiscalizacao.tipoIntegracoes.some(x => x == value.id))
            .map(value => ({ value: value.id, label: value.identificacao }))
          }
          invalid={!!errors.tipoIntegracoes}
          multiple
          disabled={!editavel}
        />
      </Col>

      {listmethodsIntregacao.length > 0 &&
        <Col md={12} lg={12}>
          <TextField
            type={"select"}
            name={"integracoes"}
            label={"Integração"}
            multiple
            value={
              listmethodsIntregacao
                .filter(value => tipoDeFiscalizacao.integracoes.some(x => x == value.id))
                .map(v => { return { value: v.id.toString(), label: v.identificacao } })
            }
            options={listmethodsIntregacao.map(v => { return { value: v.id.toString(), label: v.identificacao } })}
            onChange={onChangeMultiple}
            maxLength={100}
            disabled={!editavel}
          />
        </Col>
      }

      <Col md={12} lg={12} className='mt-3'>
        <Row className='d-flex align-items-center justify-content-between mb-2'>
          <Col md="6" lg="6" className='text-start'>
            <h5 className='text-secondary'>Termo de Inscrição em Dívida Ativa</h5>
          </Col>
          <Col md="6" lg="6" className={`text-end ${editavel ? "" : "d-none"}`}>
            <Button
              color='dark'
              className='text-white fw-bold'
              onClick={() => setIsModalListaVariaveis(true)}
            >
              <FontAwesomeIcon icon={faFileAlt} />  Visualizar lista de variáveis
            </Button>
          </Col>
        </Row>
        {isModalListaVariaveis &&
          <ModalCustomized
            toggle={toggleModalListaVariaveis}
            isOpen={isModalListaVariaveis}
            btnClose={toggleModalListaVariaveis}
            title={"Lista de variáveis"}
          >
            <TabelaListagemFichas
              options={{ print: false, search: true, pagination: true }}
              headers={[
                { value: "Código", objectValue: "codigo", align: "left" },
                { value: "Descrição", objectValue: "descricao", align: "left" }
              ]}
              items={listaVariaveisSistema.filter(v => v.tipo == "Infração")}
            />
          </ModalCustomized>}
        <RichTextEditor
          key={tipoDeFiscalizacao.id ?? "new"}
          name={"termoDividaAtiva"}
          value={tipoDeFiscalizacao.termoDividaAtiva ?? ""}
          onChange={onChange}
          disabled={!editavel}
        />
      </Col>

      <Col md={12} lg={12} className={`d-flex align-items-center justify-content-center mt-3 ${editavel ? "" : "d-none"}`}>
        <Button
          color={tipoDeFiscalizacao.id ? 'warning text-white' : 'success'}
          onClick={salvarTipoFiscalizacao}
        >
          {tipoDeFiscalizacao.id ? <><FontAwesomeIcon icon={faEdit} /> Atualizar</> : "+ Cadastrar"}
        </Button>
      </Col>
    </Row>
  </>
}

